import PropTypes from "prop-types"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_WEB_KEY

const RecaptchaProvider = ({ children }) => {
  if (!RECAPTCHA_KEY) {
    return children
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_KEY}
      scriptProps={{ async: true, defer: true }}
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}

RecaptchaProvider.propTypes = {
  children: PropTypes.node,
}

export default RecaptchaProvider
